import React from "react";
import { sanityClient } from "../sanityClient";

export type TService = {
  label: string;
  price: number;
  priceCanVary: boolean;
  subLabel: string;
  detail: boolean; //display at bottom of table
};

export type TBusinessDay = {
  title: string;
  hours: TBusinessHours;
};

export type TEvent = {
  title: string;
  description: string;
  location: string;
  startDateTime: string;
  endDateTime: string;
  image: string;
  eventUrl: string;
  extraInfo: Array<string>;
};

export type TReview = {
  reviewerName: string;
  reviewFor: string;
  rating: number;
  comment: string;
};

type TBusinessHours = {
  [key: string]: { open: string; close: string; closed: boolean };
  monday: { open: string; close: string; closed: boolean };
  tuesday: { open: string; close: string; closed: boolean };
  wednesday: { open: string; close: string; closed: boolean };
  thursday: { open: string; close: string; closed: boolean };
  friday: { open: string; close: string; closed: boolean };
  saturday: { open: string; close: string; closed: boolean };
  sunday: { open: string; close: string; closed: boolean };
};

export default function useSanity() {
  async function getSalonServicesHairCuts() {
    const query = `*[_type == "service"] | order(label asc){
        label,
        price,
        priceCanVary,
        subLabel,
        detail,
    }`;

    const result = await sanityClient.fetch<TService[]>(query);
    return result;
  }

  async function getSalonServicesColour() {
    const query = `*[_type == "salon-services-colour"] | order(label asc){
        label,
        price,
        priceCanVary,
        subLabel,
        detail,
    }`;

    const result = await sanityClient.fetch<TService[]>(query);
    return result;
  }

  async function getSalonServicesOther() {
    const query = `*[_type == "salon-services-other"] | order(label asc){
        label,
        price,
        priceCanVary,
        subLabel,
        detail,
    }`;

    const result = await sanityClient.fetch<TService[]>(query);
    return result;
  }

  async function getMobileServices() {
    const query = `*[_type == "mobile-services"] | order(label asc){
        label,
        price,
        priceCanVary,
        subLabel,
        detail,
    }`;

    const result = await sanityClient.fetch<TService[]>(query);
    return result;
  }

  async function getWellnessKellyServices() {
    const query = `*[_type == "wellness-kelly-services"] | order(label asc){
        label,
        price,
        priceCanVary,
        subLabel,
        detail,
    }`;

    const result = await sanityClient.fetch<TService[]>(query);
    return result;
  }

  async function getWellnessJessicaServices() {
    const query = `*[_type == "wellness-jessica-services"] | order(label asc){
        label,
        price,
        priceCanVary,
        subLabel,
        detail,
    }`;

    const result = await sanityClient.fetch<TService[]>(query);
    return result;
  }

  async function getBusinessHours() {
    const query = `*[_type == "salon-business-hours"]{
        title,
        hours
    }`;

    const result = await sanityClient.fetch<TBusinessDay[]>(query);
    return result;
  }

  async function getLashExtensions() {
    const query = `*[_type == "other-services-lash-extensions"]{
        label,
        price,
        priceCanVary,
        subLabel,
        detail,
        group
    }`;

    const result = await sanityClient.fetch<Array<TService & { group: string }>>(query);
    return result;
  }

  async function getEvents() {
    const query = `*[_type == "event" && endDateTime > now()] | order(startDateTime asc){
        title,
        description,
        startDateTime,
        endDateTime,
        location,
        eventUrl,
        extraInfo,
        image
    }`;

    const result = await sanityClient.fetch<Array<TEvent>>(query);
    return result;
  }

  async function getReviews(offset = 0, limit = 5) {
    const query = `*[_type == "review"] | order(_createdAt desc) [${offset}...${offset + limit}]{
      reviewerName,
      reviewFor,
      rating,
      comment
    }`;

    const result = await sanityClient.fetch<Array<TReview>>(query);
    return result;
  }

  return {
    getSalonServicesHairCuts,
    getSalonServicesColour,
    getSalonServicesOther,
    getMobileServices,
    getWellnessKellyServices,
    getWellnessJessicaServices,
    getBusinessHours,
    getLashExtensions,
    getEvents,
    getReviews,
  };
}
